export default __webpack_public_path__ + "static/media/wh-hero.55bf039b.png";